import { render, staticRenderFns } from "./stockTransaction.vue?vue&type=template&id=36c6b3fb&"
import script from "./stockTransaction.vue?vue&type=script&lang=js&"
export * from "./stockTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports